import type { Tuple5 } from '@/common/types';
import Jersey from '../Jersey/Jersey';
import LeagueStatsTable from './LeagueStatsTable';
import TeamNumber from './TeamNumber';
import LeagueName from './LeagueName';
import type { JerseySize } from '../Jersey/Jersey.types';

export interface SingleJerseyWithStatsProps {
  /** URL of the jersey image. */
  jerseySrc: string;
  /** Jersey size in pixels. */
  size?: JerseySize;
  /** When true, shows overlay over the jersey. */
  withOverlay?: boolean;
  /** Team/position number under the jersey (e.g. 17). The '#' is rendered automatically with secondary styling. */
  teamNumber: number;
  /** League name displayed under the number (e.g. "Premier League"). */
  leagueName: string;
  /** Column headers for the stats row – exactly 5 entries (e.g. ["PL", "V", "D", "L", "Pts"]). */
  statsLabels: Tuple5<string>;
  /** Values for each stat column, in the same order as statsLabels – exactly 5 entries. Omit to hide the table. */
  statsValues?: Tuple5<string | number>;
  /** Optional className for the root wrapper. */
  className?: string;
}

export default function SingleJerseyWithStats({
  jerseySrc,
  size = 95,
  withOverlay = true,
  teamNumber,
  leagueName,
  statsLabels,
  statsValues,
  className = '',
}: SingleJerseyWithStatsProps) {
  return (
    <div className={`flex flex-col items-center shrink-0 w-[168px] h-[144px] ${className}`}>
      <div className="relative flex h-[95px] w-[95px] justify-center">
        <Jersey jerseySrc={jerseySrc} size={size} withOverlay={withOverlay} />
        <div className="absolute bottom-0 left-0 right-0 flex flex-col items-center justify-end">
          <TeamNumber value={teamNumber} />
          <LeagueName name={leagueName} />
        </div>
      </div>
      <div className="mt-[8px]">
        <LeagueStatsTable labels={statsLabels} values={statsValues} />
      </div>
    </div>
  );
}
